export const formatHourRange = (hour) => {
  const startHour = hour % 24;
  const endHour = (hour + 1) % 24;

  const format = (h) => {
    const suffix = h >= 12 ? 'PM' : 'AM';
    const hour12 = h % 12 === 0 ? 12 : h % 12;
    return `${hour12} ${suffix}`;
  };

  return `${format(startHour)} – ${format(endHour)}`;
};

export const findBestAndWorstHour = (data) => {
  if (!Array.isArray(data) || data.length === 0) return null;

  const best = data.reduce(
    (max, item) => (item.sales > max.sales ? item : max),
    data[0]
  );
  const worst = data.reduce(
    (min, item) => (item.sales < min.sales ? item : min),
    data[0]
  );

  return {
    bestHour: formatHourRange(best.name),
    bestSales: best.sales,
    worstHour: formatHourRange(worst.name),
    worstSales: worst.sales
  };
};

export const generateGraphData = (salesPerHour, MAX_SALES) => {
  const to12h = (h) => {
    const hour12 = h % 12 === 0 ? 12 : h % 12;
    const suffix = h < 12 ? 'AM' : 'PM';
    return `${hour12}${suffix}`;
  };

  let graph = Array.from({length: 24}, (_, i) => {
    const start = to12h(i);
    const end = to12h((i + 1) % 24);
    return {
      rawHour: i,
      name: start,
      sales: 0,
      info: `${start} - ${end}`
    };
  });

  if (salesPerHour && Array.isArray(salesPerHour)) {
    const map = new Map(salesPerHour.map((d) => [d.name, Number(d.sales)]));
    graph = graph.map((g) => ({
      ...g,
      sales: map.get(g.rawHour) ?? 0,
      remainder: Math.max(0, MAX_SALES - (map.get(g.rawHour) ?? 0))
    }));
  } else {
    graph = graph.map((g) => ({...g, remainder: MAX_SALES}));
  }

  return graph;
};

export const formatPhoneNumber = (phone) => {
  if (!phone) return '';

  const digits = phone.replace(/\D/g, '');

  if (digits.length < 10) return phone;

  let country = '';
  let rest = digits;

  if (digits.length === 11 && digits.startsWith('1')) {
    country = '+1';
    rest = digits.slice(1);
  } else if (digits.length > 10) {
    country = `+${digits.slice(0, digits.length - 10)}`;
    rest = digits.slice(-10);
  } else {
    country = '+1';
    rest = digits;
  }

  const formatted = `${rest.slice(0, 3)} ${rest.slice(3, 6)} ${rest.slice(6)}`;

  return `${country} ${formatted}`.trim();
};

export const calculatePercentage = (field1, field2) => {
  const percentage = 100 / (field1 / field2);
  return Number.isNaN(percentage) ? 0 : percentage;
};

export const roundToThousandth = (num) => {
  return Math.ceil(num / 1000) * 1000;
};
